import React, { useState, forwardRef, useImperativeHandle, useEffect  } from 'react'; // ✅ Added useImperativeHandle
import ChatbotSvg from '../../../_assets/sass/pages/chatbot/logochat.png';
import optionSVG from '../../../_assets/sass/pages/chatbot/option.svg';
import {  useIntl } from "react-intl";

const Options = forwardRef((props, ref) => {
  const {shouldFade, isScreenDisabled, incrementPage, toggleOptions ,msg,sendNewMsg,isMe} = props;
  const [isOptionsVisible, setOptionsVisible] = useState(false);
  const [isComponentVisible, setComponentVisible] = useState(!shouldFade); 
  const intl = useIntl();

  // ✅ Expose method to parent
  useImperativeHandle(ref, () => ({
    hideOptions: () => {
      setOptionsVisible(false);
    },
    showOpt:() => {
      setOptionsVisible(true);
    },
  }));

    // ✅ useEffect to show the component only if shouldFade is true
    useEffect(() => {
      let timer;
      if (shouldFade) {
        timer = setTimeout(() => {
          setComponentVisible(true);
        }, 4000);
      }

      // Cleanup function to clear the timer
      return () => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    }, [shouldFade]); // Re-run effect if shouldFade prop changes
  
  const toggleOpt = () => {
    setOptionsVisible((prev) => !prev);
    toggleOptions(); 
  };

 const getMessageTime = () => {
    if (msg && msg.initMessage && msg.initMessage.time) {
      return msg.initMessage.time;
    }
    return '';
  };

  const getMessageText = () => {
    if (!msg) return '';
    
    if (Array.isArray(msg) && msg.length > 0 ) {
      if (msg[0].parentId === 5 && msg[0].message) {
        return msg[0].message;
      }
    }
    
    if (msg.initMessage && msg.initMessage.text) {
      return msg.initMessage.text;
    }
    
    return ''; 
  };

 if (!isComponentVisible) {
    return null; 
  }


  return (
    <>
      {/* Initial Message Box */}
      <span className={`message message2 ${isOptionsVisible ? 'hide' : ''}  ${isMe ? 'disabled' : ''} ${shouldFade==true ? 'fade-out' : ''}`}>
        <span className="tuser">
          <img src={ChatbotSvg} width="30px" alt="Chatbot Icon" />{intl.formatMessage({ id: "CHAT.KOREKSUPPORT" })}
        </span>
        <div className="tdata">
          {getMessageText()} <br />
          <span className="time">{getMessageTime()}</span>
        </div>

        <div className="options" onClick={toggleOpt}>
         {msg && Array.isArray(msg) && msg.length > 0  && msg[0].parentId ==5 ? "Services" : "Options"}  <img src={optionSVG} alt="Options Icon" />
        </div>
      </span> 

     {isMe==false && (
      <div className={`ctx ${isOptionsVisible ? '' : 'hide'} ${isScreenDisabled ? 'disable' : ''}`}>
        <div className="rds">
           {msg && msg.availableTypes && msg.availableTypes.map((answer, index) => (
            <label
              key={msg.id}
              onClick={(e) => {
                e.stopPropagation(); 
                incrementPage(answer.id);
                if(answer.id != 0)
                  sendNewMsg(answer.id,null,"");
              }}
            >
              <div className="icon"><img src={answer.icon} /></div>
              <div className="text-container">
                <h2 className="title">{answer.title}</h2>
                <p className="subtitle">{answer.subTitle}</p>
              </div>
            </label>
          ))}
             {Array.isArray(msg) && msg.length > 0 && msg[0] && msg[0].services && msg[0].services.length > 0 && msg[0].services.map((answer, index) => (
            <label
              key={answer.id}
              onClick={(e) => {
                e.stopPropagation(); 
                sendNewMsg(msg[0].parentId,answer.id+"_"+answer.name+"_"+answer.icon,"");
              }}
            >
              <div className="icon"><img src={answer.icon} /></div>
              <div className="text-container">
                <h2 className="title">{answer.name}</h2>
              </div>
            </label>
          ))}
        </div>
      </div>
     )}
    </>
  );
});

export default Options;
